import { boolean, object, string } from "yup";

const crFilterSchema = object().shape({
  id: string().label("Layout").max(10),
  description: string().label("Description").max(30),
  public: boolean().label("Public"),
});

export default crFilterSchema;
